export enum SignupScreenProgressState {
  StepPersonalInfo = 'PersonalInfo',
  StepPassword = 'Password',
  StepTermsAndConditions = 'TermsAndConditions',
  StepValidateEmail = 'ValidateEmailAddress',
}
